import React, { useState } from 'react'
import {
    IconButton,
    Tooltip
} from '@material-ui/core'
import { FaMoon } from 'react-icons/fa'

import store from '../../redux/store'
import { TOGGLE_THEME } from '../../redux/types'

const ThemeToggler = (): any => {
    const [isDark, setIsDark] = useState(false)

    store.subscribe(() => {
        setIsDark(store.getState().UI.dark)
    })

    const handleClick = () => {
        store.dispatch({
            type: TOGGLE_THEME
        })
    }

    if (!isDark)
        return (
            <Tooltip title="Switch to dark mode">
                <IconButton onClick={handleClick}>
                    <FaMoon />
                </IconButton>
            </Tooltip>
        )
    else
        return (
            <p></p>
        )
}

export default ThemeToggler